import { createRouter, createWebHistory } from "vue-router";
import home from "../views/Home.vue";
import orderMain from "../views/user/OrderMain.vue";
import orderTable from "../views/user/OrderTable.vue";

const routes = [
  { path: "/", name: "home", component: home },
  { path: "/order/main", name: "orderMain", component: orderMain },
  { path: "/order/table", name: "orderTable", component: orderTable },
  {
    path: "/order/main/:receiptYn",
    name: "order-main",
    component: orderMain,
    props: true,
  }, //order param
  {
    path: "/order/main/:tableYn",
    name: "order-main-table",
    component: orderMain,
    props: true,
  }, //order param
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
